import React from 'react';
import angular from 'angular';
import { react2angular } from 'react2angular';
import { SuggestedThresholdButton as ReactSuggestedThresholdButton } from '@splunk/olly-imm/build/detectors/SuggestedThresholdButton/SuggestedThresholdButton';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../../../../common/theme/ThemeProvider';

type Props = React.ComponentProps<typeof ReactSuggestedThresholdButton>;

const SuggestedThresholdButton: React.FC<Props> = (props) => {
    const themeKey = useLegacyThemeServiceKey();
    return (
        <ThemeProvider colorScheme={themeKey}>
            <ReactSuggestedThresholdButton {...props} />
        </ThemeProvider>
    );
};

export const suggestedThresholdButton = react2angular(SuggestedThresholdButton, [
    'status',
    'value',
    'onApply',
    'formatValue',
    'disabled',
]);

angular
    .module('signalview.detector.rule')
    .component('suggestedThresholdButton', suggestedThresholdButton);
